'use client';

import { Divider } from '@common/components';
import { SvgDelete, SvgLogo } from '@common/icon';
import { cn } from '@core/utils';

import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';

import { useInviteEventPeriodValue } from '../invite/_hooks/useInviteEventPeriodValue';
import styles from './MainBanner.module.scss';
import { PopcornEffect } from './PopcornEffect';

export const MainBanner = () => {
  const eventPeriodText = useInviteEventPeriodValue(
    '12.01 - 12.15',
    '12.16 - 12.31',
    {
      ssrFallbackValue: '-',
    },
  );
  const isSecondDecemberEvent = useInviteEventPeriodValue(false, true, {
    ssrFallbackValue: false,
  });

  return (
    <section className="relative z-[3] w-full overflow-x-clip bg-[#e4302c]">
      <div className={styles.stripe} />

      <div className="mx-auto flex max-w-[375px] flex-col items-center px-32 pt-30">
        <div className="flex flex-col items-center gap-20 pb-12">
          <div
            className={cn(
              'flex items-center gap-8 px-16 py-8',
              styles.fadeInUp,
            )}
          >
            <SvgLogo className="h-19 w-55 text-Gray-white" />
            <SvgDelete className="size-14 text-Gray-white" />
            <svg
              width="82"
              height="23"
              viewBox="0 0 82 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.0062 11.5C23.0062 17.8559 17.8559 23 11.5 23C5.14409 23 0 17.8497 0 11.5C0 5.15027 5.15027 0 11.5 0C17.8497 0 23.0062 5.15027 23.0062 11.5Z"
                fill="white"
              />
              <path
                d="M16.9046 10.6978C15.0745 9.45502 12.7374 9.962 11.5071 11.8292C10.4807 13.3935 8.93502 13.5851 8.33529 13.5851C6.37534 13.5851 5.03985 12.2125 4.64415 10.7843C4.64415 10.7843 4.63797 10.7534 4.63179 10.741C4.63179 10.7225 4.62561 10.7101 4.61942 10.6916C4.46485 10.098 4.42157 9.81362 4.42157 9.18297C4.42157 5.78243 7.91486 1.99238 12.9415 1.99238C17.9681 1.99238 21.0348 5.91227 21.8014 8.08862C21.7891 8.05152 21.7705 8.01442 21.7581 7.97115C20.299 3.7112 16.2554 0.644531 11.4947 0.644531C5.50975 0.644531 0.65625 5.49803 0.65625 11.483C0.65625 16.8373 4.51432 21.4187 9.8748 21.4187C14.1409 21.4187 17.0159 19.026 18.3267 15.7244C19.0501 13.919 18.5369 11.7983 16.8985 10.6854"
                fill="#003668"
              />
              <path
                d="M21.8635 8.30873C21.2267 6.18185 18.2652 1.99609 12.9418 1.99609C7.91516 1.99609 4.42188 5.78615 4.42188 9.18669C4.42188 9.81733 4.45897 10.1017 4.61972 10.6953C4.55171 10.4356 4.5208 10.1759 4.5208 9.92244C4.5208 6.3797 8.06972 3.92513 11.7176 3.92513C16.6576 3.92513 20.6579 7.9254 20.6579 12.8654C20.6579 16.7359 18.4321 20.087 15.1985 21.6945C19.3719 20.1859 22.3458 16.1918 22.3458 11.4991C22.3458 10.3861 22.1974 9.40927 21.8697 8.30873"
                fill="#E6002D"
              />
              <path
                d="M30.4225 6.90465V6.03906H31.7827V6.90465H33.6746V7.9681H28.3203V6.90465H30.4225ZM33.452 10.3918C33.452 10.6947 33.3902 10.9729 33.2604 11.2326C33.1367 11.4923 32.9636 11.7211 32.7534 11.9189C32.5432 12.1168 32.2959 12.2713 32.0114 12.3826C31.7332 12.4939 31.4303 12.5557 31.1088 12.5557C30.7872 12.5557 30.4843 12.5001 30.2061 12.3826C29.9278 12.2713 29.6805 12.1106 29.4641 11.9189C29.2477 11.7272 29.0808 11.4923 28.9571 11.2326C28.8335 10.9729 28.7655 10.6947 28.7655 10.3918C28.7655 10.0888 28.8273 9.81057 28.9571 9.54471C29.0808 9.27885 29.2539 9.05008 29.4641 8.85224C29.6743 8.65439 29.9217 8.49981 30.2061 8.38234C30.4843 8.26487 30.7872 8.20922 31.1088 8.20922C31.4303 8.20922 31.7332 8.26487 32.0114 8.38234C32.2897 8.49981 32.537 8.65439 32.7534 8.85224C32.9636 9.05008 33.1367 9.27885 33.2604 9.54471C33.384 9.81057 33.452 10.0888 33.452 10.3918ZM32.2588 10.3794C32.2588 10.0702 32.1475 9.80439 31.9249 9.58181C31.7023 9.35922 31.4303 9.24793 31.1149 9.24793C30.7996 9.24793 30.5338 9.35922 30.3112 9.58181C30.0886 9.80439 29.9773 10.0702 29.9773 10.3794C29.9773 10.6885 30.0886 10.9482 30.3112 11.1708C30.5338 11.3934 30.7996 11.5047 31.1149 11.5047C31.4303 11.5047 31.7023 11.3934 31.9249 11.1708C32.1475 10.9482 32.2588 10.6885 32.2588 10.3794ZM36.7722 14.5528C36.7722 14.8681 36.7042 15.1649 36.5682 15.4431C36.4321 15.7213 36.259 15.9686 36.0364 16.1788C35.8077 16.3891 35.5418 16.5622 35.245 16.6858C34.9483 16.8095 34.6268 16.8775 34.2867 16.8775C33.9467 16.8775 33.6252 16.8157 33.3222 16.6858C33.0192 16.5622 32.7534 16.3891 32.5246 16.1788C32.302 15.9686 32.1289 15.7213 31.9929 15.4431C31.8569 15.1649 31.795 14.8681 31.795 14.5528C31.795 14.2374 31.8631 13.9345 31.9929 13.6563C32.1289 13.3719 32.302 13.1245 32.5246 12.9143C32.7534 12.7041 33.0192 12.531 33.3222 12.4073C33.6252 12.2837 33.9467 12.2157 34.2867 12.2157C34.6268 12.2157 34.9421 12.2775 35.245 12.4073C35.5418 12.531 35.8077 12.7041 36.0364 12.9143C36.259 13.1245 36.4321 13.378 36.5682 13.6563C36.7042 13.9407 36.7722 14.2374 36.7722 14.5528ZM35.5233 14.5404C35.5233 14.2127 35.3996 13.9221 35.1585 13.6748C34.9112 13.4275 34.6206 13.31 34.2867 13.31C33.9528 13.31 33.6561 13.4337 33.4149 13.6748C33.1738 13.9221 33.0563 14.2065 33.0563 14.5404C33.0563 14.8743 33.18 15.1587 33.4149 15.3998C33.6561 15.6409 33.9467 15.7584 34.2867 15.7584C34.6268 15.7584 34.9174 15.6409 35.1585 15.3998C35.4058 15.1587 35.5233 14.8743 35.5233 14.5404ZM35.4985 11.8942H34.3176V6.26783H35.4985V8.49982H36.5496V6.25546H37.78V12.0364H36.5496V9.66218H35.4985V11.8942Z"
                fill="white"
              />
              <path
                d="M39.2702 7.65512V6.55459H45.1809V7.65512H42.6645L45.286 10.8578L44.3895 11.5936L42.2874 8.96588L40.1914 11.7667L39.2578 11.0124L41.8731 7.65512H39.2702ZM47.45 14.3696C47.45 14.7159 47.382 15.0436 47.2398 15.3465C47.0976 15.6495 46.9059 15.9153 46.671 16.1441C46.4299 16.3729 46.1393 16.5522 45.8116 16.6882C45.4839 16.8242 45.1377 16.8922 44.7791 16.8922C44.4204 16.8922 44.068 16.8242 43.7403 16.6882C43.4065 16.5522 43.1221 16.3729 42.8809 16.1441C42.646 15.9153 42.4543 15.6495 42.3121 15.3465C42.1699 15.0436 42.1019 14.7159 42.1019 14.3696C42.1019 14.0234 42.1699 13.6957 42.3121 13.3866C42.4543 13.0774 42.646 12.8116 42.8809 12.5828C43.1221 12.354 43.4127 12.1747 43.7403 12.0387C44.0742 11.9027 44.4204 11.8409 44.7791 11.8409C45.1377 11.8409 45.4839 11.9089 45.8116 12.0387C46.1393 12.1747 46.4237 12.354 46.671 12.5828C46.9059 12.8116 47.0976 13.0774 47.2398 13.3866C47.382 13.6957 47.45 14.0234 47.45 14.3696ZM46.1949 14.3573C46.1949 13.9739 46.0527 13.6401 45.7683 13.3557C45.4839 13.0774 45.15 12.9352 44.7667 12.9352C44.3833 12.9352 44.0495 13.0774 43.7651 13.3557C43.4868 13.6339 43.3446 13.9678 43.3446 14.3573C43.3446 14.7468 43.4868 15.0745 43.7651 15.3527C44.0433 15.6309 44.3772 15.767 44.7667 15.767C45.1562 15.767 45.4901 15.6309 45.7683 15.3527C46.0527 15.0745 46.1949 14.7468 46.1949 14.3573ZM47.0481 11.7172V9.48523H45.1315V8.38469H47.0481V6.25781H48.328V11.7172H47.0481Z"
                fill="white"
              />
              <path
                d="M55.6881 9.139C55.6881 9.52233 55.6139 9.88711 55.4594 10.2272C55.3048 10.5672 55.0946 10.864 54.8287 11.1237C54.5629 11.3772 54.2537 11.575 53.9013 11.7296C53.5489 11.878 53.1717 11.9522 52.7698 11.9522C52.368 11.9522 51.9908 11.878 51.6384 11.7296C51.286 11.5812 50.9768 11.3772 50.711 11.1237C50.4451 10.864 50.2349 10.5672 50.0803 10.2272C49.9258 9.88711 49.8516 9.52851 49.8516 9.139C49.8516 8.74948 49.9258 8.39088 50.0803 8.05082C50.2349 7.71077 50.4451 7.414 50.711 7.15432C50.9768 6.90082 51.286 6.70297 51.6384 6.5484C51.9908 6.40002 52.368 6.32582 52.7698 6.32582C53.1717 6.32582 53.5489 6.40002 53.9013 6.5484C54.2537 6.69679 54.5629 6.90082 54.8287 7.15432C55.0946 7.414 55.3048 7.71077 55.4594 8.05082C55.6139 8.39088 55.6881 8.75566 55.6881 9.139ZM51.7744 12.9105V15.2167H58.6991V16.3481H50.4946V12.9105H51.7744ZM54.4577 9.15136C54.4577 8.9226 54.4145 8.7062 54.3217 8.50217C54.229 8.29814 54.1115 8.11883 53.9631 7.95808C53.8024 7.80969 53.6293 7.68604 53.4252 7.59948C53.2274 7.50674 53.011 7.46346 52.7822 7.46346C52.5534 7.46346 52.337 7.50674 52.133 7.59948C51.929 7.69222 51.7497 7.80969 51.5889 7.95808C51.4405 8.11265 51.3169 8.29814 51.2303 8.50217C51.1376 8.7062 51.0943 8.9226 51.0943 9.15136C51.0943 9.38012 51.1376 9.59652 51.2303 9.79437C51.3231 9.99222 51.4405 10.1777 51.5889 10.3323C51.7497 10.4807 51.929 10.6043 52.133 10.6909C52.337 10.7836 52.5534 10.8269 52.7822 10.8269C53.011 10.8269 53.2274 10.7836 53.4252 10.6909C53.6293 10.5981 53.8024 10.4807 53.9631 10.3323C54.1115 10.1777 54.2352 9.99222 54.3217 9.79437C54.4145 9.59652 54.4577 9.38012 54.4577 9.15136ZM58.4395 12.8549H57.1596V6.25781H58.4395V8.50217H59.9172V9.76964H58.4395V12.8549Z"
                fill="white"
              />
              <path
                d="M60.8327 7.65512V6.55459H66.7434V7.65512H64.2394L66.8547 11.507L65.884 12.1562L63.8499 9.05862L61.8157 12.2366L60.8203 11.575L63.4233 7.64894H60.8327V7.65512ZM61.5437 16.3543V12.9167H62.8235V15.2229H69.9894V16.3543H61.5499H61.5437ZM68.6106 12.8549V9.81292H66.694V8.68147H68.6106V6.25781H69.8905V12.8549H68.6106Z"
                fill="white"
              />
              <path
                d="M71.6484 12.7687H81.1081V13.9001H77.0213V16.5464H75.7353V13.9001H71.6546V12.7687H71.6484ZM73.6702 7.73589H79.0863V6.4375H80.3538V11.3899H72.4089V6.4375H73.6764V7.73589H73.6702ZM79.0802 8.84879H73.664V10.2647H79.0802V8.84879Z"
                fill="white"
              />
            </svg>
          </div>

          <div className="flex w-full items-center justify-center gap-14 rounded-xsmall border-1 border-Gray-white px-14 py-4">
            <span className="font-700 text-Gray-white typo-body3">
              고향사랑기부
            </span>
            <Divider className="h-2 flex-1 bg-Gray-white" />
            <span className="font-700 text-Gray-white typo-body3">
              12월 한정 EVENT
            </span>
          </div>

          <div className={cn(styles.fadeInScale, 'relative z-10 h-89 w-300')}>
            <Image
              src={`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/max.png`}
              alt="MAX"
              fill
              priority
              className="object-contain"
            />
            {isSecondDecemberEvent ? (
              <Image
                src={`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/encore-sticker.png`}
                alt="앵콜"
                className="absolute -right-24 top-33 object-contain"
                width={76}
                height={76}
              />
            ) : null}
          </div>
        </div>

        <div className="flex flex-col gap-20 text-center">
          <div
            className={cn(
              'font-700 text-[#ffcf9f] typo-h7',
              styles.fadeInStagger1,
            )}
          >
            {isSecondDecemberEvent ? (
              <p>
                올해 정말 마지막! 고향사랑기부!
                <br />
                아직 참여하지 않으셨다면!
                <br />
                <span className="text-Gray-white">
                  지금 최대 혜택과 함께 참여하세요!
                </span>
              </p>
            ) : (
              <p>
                1년에 단 한 번!{' '}
                <span className="text-Gray-white">총 1억원 혜택!</span>
                <br />
                고향사랑기부 올해 최대 리워드
                <br />
                매일 매일{' '}
                <span className="text-Gray-white">현금 MAX로 돌려드려요!</span>
              </p>
            )}
          </div>
          <p
            className={cn(
              'font-700 tracking-[1.44px] text-Gray-white typo-body2',
              styles.fadeInStagger2,
            )}
          >
            {eventPeriodText}
          </p>
        </div>

        <div
          className={cn(
            'relative z-[3] -mb-18 h-229 w-[417px] overflow-visible',
            styles.bounceIn,
          )}
        >
          <Image
            src={`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/santa.png`}
            alt="산타 캐릭터"
            fill
            priority
            className="object-contain"
          />
          <PopcornEffect />
        </div>
      </div>

      <div className={styles.stripe} />
    </section>
  );
};
